<scale-telekom-app-shell>
  <app-header slot="header"></app-header>

  <div class="workspace-layout" [class.sidebar-collapsed]="sidebarCollapsed()">
    <nav
      class="app-sidebar"
      [attr.aria-expanded]="!sidebarCollapsed()"
      aria-label="Application navigation"
    >
      <button
        class="sidebar-toggle"
        (click)="toggleSidebar()"
        [title]="sidebarCollapsed() ? 'Expand menu  (Ctrl+\\)' : 'Collapse menu  (Ctrl+\\)'"
        aria-label="Toggle sidebar"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" class="toggle-icon" aria-hidden="true">
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </svg>
      </button>

      <ul class="nav-list" role="list">
        @for (item of navItems; track item.route) {
          <li class="nav-item" [class.active]="isActive(item)">
            <button
              class="nav-btn"
              (click)="navigate(item.route)"
              [attr.title]="sidebarCollapsed() ? item.label : null"
              [attr.aria-current]="isActive(item) ? 'page' : null"
              [attr.aria-label]="item.label"
            >
              <span class="active-bar" aria-hidden="true"></span>

              <span class="nav-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path [attr.d]="item.iconPath"></path>
                </svg>
              </span>

              <span class="nav-label">{{ item.label }}</span>
            </button>
          </li>
        }
      </ul>

      <div class="sidebar-hint" aria-hidden="true">
        <span>Ctrl + \</span>
      </div>
    </nav>

    <main class="page-content" id="main-content" tabindex="-1">
      <div class="page-enter">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

  <app-footer slot="footer"></app-footer>
</scale-telekom-app-shell>

<app-notification />
<app-loading-spinner />
<app-ai-chat />